export default "__VITE_ASSET__Cq9pW3mq__"